/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognitive_Context_And_TonalityInputs */

const en_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cognitive Context & Tonality`)
};

const es_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto cognitivo y tonalidad`)
};

const fr_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexte cognitif et Tonalité`)
};

const de_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kognitiver Kontext & Tonalität`)
};

const ja_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認知的コンテキストとトーン`)
};

const zh_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认知上下文与语调`)
};

const ar_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السياق المعرفي ونبرة الصوت`)
};

const id_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteks Kognitif & Nada Bahasa`)
};

const it_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto Cognitivo & Tonalità`)
};

const ru_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когнитивный контекст и тональность`)
};

const pt_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto Cognitivo e Tonalidade`)
};

const ko_cognitive_context_and_tonality = /** @type {(inputs: Cognitive_Context_And_TonalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인지 컨텍스트 및 어조`)
};

/**
* | output |
* | --- |
* | "Cognitive Context & Tonality" |
*
* @param {Cognitive_Context_And_TonalityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cognitive_context_and_tonality = /** @type {((inputs?: Cognitive_Context_And_TonalityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognitive_Context_And_TonalityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognitive_context_and_tonality(inputs)
	if (locale === "es") return es_cognitive_context_and_tonality(inputs)
	if (locale === "fr") return fr_cognitive_context_and_tonality(inputs)
	if (locale === "de") return de_cognitive_context_and_tonality(inputs)
	if (locale === "ja") return ja_cognitive_context_and_tonality(inputs)
	if (locale === "zh") return zh_cognitive_context_and_tonality(inputs)
	if (locale === "ar") return ar_cognitive_context_and_tonality(inputs)
	if (locale === "id") return id_cognitive_context_and_tonality(inputs)
	if (locale === "it") return it_cognitive_context_and_tonality(inputs)
	if (locale === "ru") return ru_cognitive_context_and_tonality(inputs)
	if (locale === "pt") return pt_cognitive_context_and_tonality(inputs)
	return ko_cognitive_context_and_tonality(inputs)
});